import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ShieldLock } from "react-bootstrap-icons";
import { Seo } from "../../../components/Seo";
import { generateNoIndexSEO } from "../../../lib/seo/metaGenerators";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 16px",
      backgroundColor: "#f2f2f7",
    }}>
      <Seo {...generateNoIndexSEO("Reset Password")} />
      <div style={{ width: "100%", maxWidth: 380 }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <img src="/imgs/logo/complete-250.png" alt="FineEats" style={{ height: 72, width: "auto" }} />
        </div>

        {/* Card */}
        <div style={{
          backgroundColor: "#fff",
          borderRadius: 18,
          border: "1px solid rgba(15,23,42,0.07)",
          padding: "32px 24px 28px",
          boxShadow: "0 2px 12px rgba(15,23,42,0.06)",
          textAlign: "center",
        }}>
          {/* Icon */}
          <div style={{
            width: 64, height: 64, borderRadius: "50%",
            backgroundColor: "rgba(0,122,255,0.1)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 20px",
          }}>
            <ShieldLock size={28} color="#007aff" />
          </div>

          <h1 style={{ fontSize: "1.375rem", fontWeight: 700, color: "#1c1c1e", letterSpacing: "-0.02em", marginBottom: 8 }}>
            Check your email
          </h1>

          <p style={{ fontSize: "0.9375rem", color: "rgba(60,60,67,0.6)", lineHeight: 1.5, marginBottom: email ? 4 : 28 }}>
            We sent a password reset link to
          </p>

          {email && (
            <p style={{ fontSize: "0.9375rem", fontWeight: 600, color: "#1c1c1e", marginBottom: 28, wordBreak: "break-all" }}>
              {email}
            </p>
          )}

          <button
            onClick={() => navigate("/login")}
            style={{
              width: "100%",
              padding: "13px",
              borderRadius: 12,
              border: "none",
              backgroundColor: "rgba(0,122,255,0.1)",
              color: "#007aff",
              fontSize: "0.9375rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Back to Sign In
          </button>
        </div>

      </div>
    </div>
  );
};

export default ResetPassword;
